import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmIncomeChangeModalComponent } from '../../../profile/components/confirm-income-change-modal/confirm-income-change-modal.component';
import { AuthLinkType } from '../../../../enums/event/event-data.enum';
import { DLEntry } from '../../../shared/models/description-list-entry.model';
import { ConfirmResidenceChangeModalComponent } from '../confirm-residence-change-modal/confirm-residence-change-modal.component';
import { ComponentType } from '@angular/cdk/portal';
import { ProfileModalData } from '../../models/profile-details.model';

const modalMapper: Record<ProfileModalData['profileType'], ComponentType<any>> = {
  income: ConfirmIncomeChangeModalComponent,
  residence: ConfirmResidenceChangeModalComponent,
};

@Component({
    selector: 'app-profile-details',
    templateUrl: './profile-details.component.html',
    styleUrls: ['./profile-details.component.scss'],
    standalone: false
})
export class ProfileDetailsComponent {
  @Input() entries: DLEntry[];
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Input() modalData: ProfileModalData;
  AuthLinkType = AuthLinkType;

  constructor(private readonly dialog: MatDialog) {}


  looksGood() {
    this.dialog.open(modalMapper[this.modalData.profileType], {
      data: this.modalData,
      maxWidth: '529px',
      panelClass: 'be-dialog',
    });
  }
}
